var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineComponent as _defineComponent } from 'vue';
import { BAlert, BCard } from "bootstrap-vue";
import { storeToRefs } from "pinia";
import { computed, ref, watch } from "vue";
import { fromSimple } from "@/components/Workflow/Editor/modules/model";
import { getWorkflowFull, getWorkflowInfo } from "@/components/Workflow/workflows.services";
import { useDatatypesMapper } from "@/composables/datatypesMapper";
import { provideScopedWorkflowStores } from "@/composables/workflowStores";
import { useUserStore } from "@/stores/userStore";
import { assertDefined } from "@/utils/assertions";
import Heading from "@/components/Common/Heading.vue";
import LoadingSpan from "@/components/LoadingSpan.vue";
import WorkflowGraph from "@/components/Workflow/Editor/WorkflowGraph.vue";
import WorkflowInformation from "@/components/Workflow/Published/WorkflowInformation.vue";
import WorkflowRunButton from "@/components/Workflow/WorkflowRunButton.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'WorkflowQuickView',
    props: {
        id: null
    },
    setup(__props) {
        const props = __props;
        const userStore = useUserStore();
        const { datatypesMapper } = useDatatypesMapper();
        const { isAnonymous } = storeToRefs(userStore);
        const { stateStore } = provideScopedWorkflowStores(props.id);
        stateStore.scale = 0.75;
        const loading = ref(true);
        const errored = ref(false);
        const errorMessage = ref("");
        const workflow = ref(null);
        const workflowInfo = ref();
        const runButtonTitle = computed(() => {
            if (isAnonymous.value) {
                return "Log in to run workflow";
            }
            else {
                return "Run workflow";
            }
        });
        watch(() => props.id, (id) => __awaiter(this, void 0, void 0, function* () {
            var _a;
            workflowInfo.value = undefined;
            loading.value = true;
            errored.value = false;
            errorMessage.value = "";
            try {
                const [workflowInfoData, fullWorkflow] = yield Promise.all([getWorkflowInfo(id), getWorkflowFull(id)]);
                assertDefined(workflowInfoData.name);
                workflowInfo.value = workflowInfoData;
                workflow.value = fullWorkflow;
                fromSimple(props.id, fullWorkflow);
            }
            catch (e) {
                const error = e;
                if ((_a = error.response) === null || _a === void 0 ? void 0 : _a.data.err_msg) {
                    errorMessage.value = error.response.data.err_msg;
                }
                errored.value = true;
            }
            finally {
                loading.value = false;
            }
        }), {
            immediate: true,
        });
        return { __sfc: true, props, userStore, datatypesMapper, isAnonymous, stateStore, loading, errored, errorMessage, workflow, workflowInfo, runButtonTitle, BAlert, BCard, Heading, LoadingSpan, WorkflowGraph, WorkflowInformation, WorkflowRunButton };
    }
});
